import React, { forwardRef, Fragment } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { cn } from '../../lib/utils'
import PropTypes from 'prop-types'
import { useCommonStore } from '../../Common/store/CommonStore'
import * as OnboardEntity from '../../Entities/OnBoardingContainerTypes'
import { get } from 'src/Containers/Auth/Store/Store'

const Input = forwardRef(({onKeyDown , className, disabled, type, userId, multiple, onValueChange, readOnly, value, name = '', errors, placeholder, rules, control, label, required, key, setError, clearErrors, maxLength  },ref) => {
    const { control: formControl } = useForm()
    const { getExistingEmailandPhoneno } = useCommonStore()
    // const loginUserId = localStorage.getItem('userId')
                  const orgId = get("orgId");
      
    const validateEmail = async (email) => { 
      try {
        const payload = { userId: userId, emailId: email, phoneCountryCode: '', phoneCode: '', phoneNo: '', orgId};
    
        const response = await getExistingEmailandPhoneno(payload);
    
        if (response?.data === true) { 
          setError?.(name, { type: 'manual', message: 'Email already exists' })
        } else if (response?.data === false) {
          clearErrors?.(name)
        }
      } catch (error) {
        setError?.(name, { type: 'manual', message: 'An error occurred while validating email' })
      }
    };

    const validatePhoneNo = async (phone) => { 
      try {
        const payload = { userId: userId, emailId: '', phoneCountryCode: 'IND', phoneCode: '+91', phoneNo: phone, orgId };
    
        const response = await getExistingEmailandPhoneno(payload);
    
        if (response?.data === true) { 
          setError?.(name, { type: 'manual', message: 'Phone number already exists' })
        } else if (response?.data === false) {
          clearErrors?.(name)
        }
      } catch (error) {
        setError?.(name, { type: 'manual', message: 'An error occurred while validating phone number' })
      }
    };
    
    
    return (
        <Fragment>
            {label && <label className={cn('grc-label block mb-1')}>{label}{required && <span className='text-danger'>*</span>}</label>}
            <Controller
                name={name}
                control={control || formControl}
                rules={rules}
                render={({ field: { onChange, onBlur } }) => (
                    <input
                    onKeyDown={onKeyDown}
                        key={key}
                        type={type}
                        id={name}
                        name={name}
                        disabled={disabled}
                        className={cn(disabled ? 'input-grc-disabled' : 'input-grc',
                            'flex h-9 w-[95%] rounded-lg ring-[1.5px] ring-[hsl(var(--border))] border-none bg-transparent px-3 py-3 shadow-sm transition-colors file:border-1 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:border-none focus-visible:outline-none focus-visible:ring-[1.5px] focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50',
                            { 'read-only': readOnly },                           
                            className
                        )}
                        multiple={multiple}
                        maxLength={maxLength}
                        ref={ref}
                        placeholder={placeholder}
                        onChange={(e) => { onValueChange(e, name); onChange(e.target.value) }}      
                        onBlur={async (e) => {
                          const value = e.target.value.trim()
                          const regexAlphaNumeric = /^[a-zA-Z0-9\s]+$/
                          const regexPhone = /^[0-9]{10}$/
                          const regexAlpha = /^[A-Za-z]+$/
                          const titleRegex = /^(Mr\.|Mrs\.|Ms\.|Mx\.|Dr\.)\s*/i
                          const nameWithoutTitle = value.replace(titleRegex, '').trim()
                      
                          switch (label) {
                              case OnboardEntity.PHONE_NUMBER_LABEL: {
                                  if (!regexPhone.test(value)) {
                                      setError?.(name, {
                                          type: 'manual',
                                          message: 'Phone number must be exactly 10 digits',
                                      });
                                  } else {
                                      clearErrors?.(name);
                                      if (!value) {
                                          setError?.(name, {
                                              type: 'manual',
                                              message: 'Phone is required',
                                          });
                                      } else {
                                          await validatePhoneNo(value);
                                      }
                                  }
                                  break;
                              }
                      
                              case OnboardEntity.ORGANIZATION_NAME_LABEL:
                              case OnboardEntity.INDUSTRY_LABEL: {
                                  if (!regexAlphaNumeric.test(value)) {
                                      setError?.(name, {
                                          type: 'manual',
                                          message: `${label} must not contain special characters or spaces`,
                                      });
                                  } else if (value.length > (label === OnboardEntity.ORGANIZATION_NAME_LABEL ? 50 : 30)) {
                                      setError?.(name, {
                                          type: 'manual',
                                          message: `${label} must not exceed ${
                                              label === OnboardEntity.ORGANIZATION_NAME_LABEL ? 50 : 30
                                          } characters`,
                                      });
                                  } else {
                                      clearErrors?.(name);
                                  }
                                  break;
                              }
                      
                              case OnboardEntity.EMAIL_ID_LABEL: {
                                const regexEmail = /^[a-zA-Z0-9.+-_%]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                  if (!value) {
                                      setError?.(name, {
                                          type: 'manual',
                                          message: 'Email is required',
                                      });
                                  }  else if (!regexEmail.test(value)) {
                                    setError?.(name, {
                                        type: 'manual',
                                        message: 'Enter a valid email',
                                    })
                                } else {
                                      await validateEmail(value);
                                  }
                                  break;
                              }

                              case OnboardEntity.FIRST_NAME_LABEL: {
                                if (!nameWithoutTitle) {
                                    setError?.(name, {
                                        type: 'manual',
                                        message: 'First Name cannot be empty',
                                    });
                                } else if (!regexAlpha.test(value)) {
                                    setError?.(name, {
                                        type: 'manual',
                                        message: 'First Name must contain only letters',
                                    });
                                } else if (nameWithoutTitle.length > 50) {
                                    setError?.(name, {
                                        type: 'manual',
                                        message: 'First Name must not exceed 50 characters',
                                    });
                                } else {
                                    clearErrors?.(name);
                                }
                                break;
                            }

                            case OnboardEntity.MIDDLE_NAME_LABEL: {
                                if (value.length > 30) {
                                    setError?.(name, {
                                        type: 'manual',
                                        message: 'Middle Name must not exceed 30 characters',
                                    });
                                } else {
                                    clearErrors?.(name);
                                }
                                break;
                            }
                    
                            case OnboardEntity.LAST_NAME_LABEL: {
                                if (!value) {
                                    setError?.(name, {
                                        type: 'manual',
                                        message: 'Last Name cannot be empty',
                                    });
                                } else if (!regexAlpha.test(value)) {
                                    setError?.(name, {
                                        type: 'manual',
                                        message: 'Last Name must contain only letters',
                                    });
                                } else if (value.length > 30) {
                                    setError?.(name, {
                                        type: 'manual',
                                        message: 'Last Name must not exceed 30 characters',
                                    });
                                } else {
                                    clearErrors?.(name);
                                }
                                break;
                            }
                      
                            case OnboardEntity.APARTMENT_LABEL: {
                                if (value.length > 50) {
                                    setError?.(name, {
                                        type: 'manual',
                                        message: `${label} must not exceed 50 characters`,
                                    });
                                } else {
                                    clearErrors?.(name);
                                }
                                break;
                            }
                            case OnboardEntity.PINCODE_LABEL: {
                              if (value.length > 6) {
                                  setError?.(name, {
                                      type: 'manual',
                                      message: `${label} must not exceed 6 digitss`,
                                  });
                              } else {
                                  clearErrors?.(name);
                              }
                              break;
                          }
                    
                            default: {
                                clearErrors?.(name);
                            }
                          }
                      
                          onBlur?.(e)
                      }}                                    
                        value={value || ''}
                        readOnly={readOnly}
                    />
                )}
            />
            {errors && name && errors[name] && <p className='grc-error-msg text-danger'>{errors && name && errors[name]?.message}</p>}
        </Fragment>
    )
})

Input.propTypes = {
    className: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    children: PropTypes.any,
    onValueChange: PropTypes.func,
    name: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    errors: PropTypes.any,
    rules: PropTypes.object,
    control: PropTypes.any,
    message: PropTypes.any,
    required: PropTypes.bool,
    key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setError: PropTypes.func,
    clearErrors: PropTypes.func,
    maxLength: PropTypes.any
}

export default Input
